<template>
  <div v-show="visible">
    <div class="popup_wrap save_history">
      <div class="popup_title">
        <p><span id="node_title">CELL 변경이력</span></p>
        <a>
          <div id="popup_close" class="btn_close" title="Close" @click="close"><div class="btn_close_box"><span></span><span></span></div></div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content2">
        <div class="popup_content_fix_top">
          <ul class="fix_info_list">
            <li><b>노드타입</b><span>{{tagType =='PROCESS'? '공정' : tagType == 'MATERIAL'? '재료' : '측정/분석'}}</span></li>
            <li><b>노드명</b><span>{{nodeName}}</span></li>
            <li><b>속성명</b><span>{{colName}}</span></li>
            <li><b>기본값SET</b><span>{{experimentName}}</span></li>
          </ul>
        </div><!-- class="popup_content_fix_top" -->
        <div class="popup_content_fix_bottom">
        <ul class="protocol_search_list">
          <li v-for="(history, index) in historyList" :key="index">
            <div class="protocol_search_item">
              <div class="top_info">
                <div class="txt_cont">
                  <div class="tit_label" style="margin-bottom: 5px;">
                    <span v-if="index==0" class="label_color color_02">생성</span>
                    <span v-else class="label_color color_03">변경</span>
                  </div>
                  <table class="change_info_cell">
                    <thead>
                    <tr>
                      <th>변경이전 <p class="writer_bubble_before">작성자: {{history.oldUser}}</p></th>
                      <th>변경이후 <p class="writer_bubble_after">작성자: {{history.newUser}}</p></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{{history.oldValue}}</td>
                      <td>{{history.newValue}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="bottom_info">
                <ul class="user_set">
                  <li>변경일자 : {{history.changeDate}}</li>
                </ul>
                <ul class="btn_set">
<!--                  <li><a href="#none" class="editor_move_btn">에디터로 이동</a></li>-->
                  <li class="process">
                    <a v-if="revertAvailable" class="process_chart_btn" style="cursor: pointer;" @click="revert(history.oldValue)">
                      변경이전값으로 되돌리기
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
<!--          <li>
            <div class="protocol_search_item">
              <div class="top_info">
                <div class="txt_cont">
                  <div class="tit_label">
                    <span class="label_color color_02">Full<em>|</em>프로토콜<em>|</em>P-F2-33</span>
                    <span class="label_gray">변경</span>
                  </div>
                  <a href="#none" class="tit_link">
                    <span class="highlight">XPS</span> Skutterudite계 In-doped CoSb3 소재 합성법 Skutterudite계 In-doped CoSb3
                    소재 합성법Skutterudite계 In-doped CoSb3 소재
                    합성법Skutterudite계 In-doped CoSb3 소재 합성법 Skutterudite계 In-doped CoSb3 소재 합성법 Skutterudite계 In-doped
                    CoSb3 소재 합성법
                  </a>
                  <ul class="protocol_label_list">
                    <li class="label_01"><span>MnSi1.787Al0.01 (powder - before sieving)</span></li>
                    <li class="label_04"><span>Particle size distrbution</span></li>
                    <li class="label_03"><span>Particle size distrbution</span></li>
                  </ul>
                  <p class="txt_info"><span class="highlight">XPS</span> Skutterudite, CoSb3, 합성법, 열전소재, 에너지환경</p>
                </div>
              </div>
              <div class="bottom_info">
                <ul class="user_set">
                  <li>2022.10.04</li>
                  <li>책임작성자 : 황진하</li>
                  <li>공동작성자 : 이철모</li>
                </ul>
                <ul class="btn_set">
                  <li><a href="#none" class="tree_btn">트리보기</a></li>
                  <li><a href="#none" class="wiki_btn">위키보기</a></li>
                  &lt;!&ndash; 2023-12-04 수정
                      * PDF다운로드를 에디터로 이동으로 변경
                  &ndash;&gt;
                  <li><a href="#none" class="editor_move_btn">에디터로 이동</a></li>
                  &lt;!&ndash; // 2023-12-04 수정 &ndash;&gt;
                  <li class="process"><a href="#none" class="process_chart_btn">공정도 바로가기</a></li>
                </ul>
              </div>
            </div>
          </li>-->
        </ul>

        </div><!-- class="popup_content_fix_bottom" -->
      </div>
      <div class="popup_footer">
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import {
  COL_PREFIX,PROPERTY_TYPE
} from "@/util/HubHandsonTable";
import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');

export default {
  data() {
    const initialState = {
      loading: null,
      visible: false,
      row: null,
      col: null,
      nodeName: null,
      colName: null,
      experimentName: null,
      tagType: null,
      processPropertyType: null,
      propertyType: null,
      historyList: [],
      PROPERTY_TYPE : PROPERTY_TYPE
    };
    return {
      ...initialState,
      initialState, // 초기 상태 저장
    };
  },
  components: {
    Loading,
  },
  computed: {
    ...Hub.mapGetters(
      ['hotInstance','getSaveHistoryObj','getExperimentResultMode']),
    revertAvailable(){
      return this.getExperimentResultMode!='readOnly'
           && (this.processPropertyType == 'CUSTOM' || this.processPropertyType == 'SAMPLE' || this.processPropertyType == 'DATE' )
           && (this.propertyType != this.PROPERTY_TYPE.FILE.value && this.propertyType != this.PROPERTY_TYPE.IMAGE.value)
    }
  },
  watch: {
    getSaveHistoryObj: {
      deep : true,
      async handler (value) {
        if(value.saveHistoryPopFlag === true && typeof value.cellInfo == 'object'){
          this.show();
          await this.initiallize();
        }else if(value.saveHistoryPopFlag === false){
          this.resetModalData();
        }
      }
    },
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations([
        'setSaveHistoryObj'
    ]),
    async initiallize() {
      try {
        this.loading = true;
        this.visible = true;
        const { rowId, colId, row, col, nodeName, colName, tagType, processPropertyType,propertyType } = this.getSaveHistoryObj.cellInfo; // 객체에서 키를 구조분해

        const response = await this.$wApi.experiment.history.get({
          processId : this.$route.query.processId,
          rowId : rowId,
          colId : colId.replace(COL_PREFIX,'')
        });

        if (!response?.error) {
          Object.assign(this, {row, col, nodeName, colName, tagType, processPropertyType,propertyType}); // Vue 데이터에 매핑
          this.experimentName = response.experimentName;
          this.historyList = response.historyList;
        }
      } catch (e) {
        alert(e);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async revert(oldValue){
      const flag = await window.confirm("현재 선택한 Cell의 데이터를 변경이전 값으로 되돌리시겠습니까?");
      if(flag){
        this.hotInstance.setDataAtCell(this.row, this.col, oldValue);
        alert(oldValue + "으로 변경되었습니다.")
      }
    },
    resetModalData() {
      Object.assign(this, this.initialState); // 초기 상태 복원
    },
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.setSaveHistoryObj({
        openFlag: false,
        dataObj: {}
      });
    },
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";

.save_history {
  display: block;
  position: fixed;
  width: 1200px;
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.2);
}

@media screen and (max-width: 950px) {
  .save_history {width:95%;}
}
</style>